export default {
  data() {
    return {
      countries: [],
      countriesSelect: [],
      notificationTypes: [],
      notificationTypesSelect: [],
      warehouses: [],
      warehousesSelect: [],
      warehousesById: [],
      warehousesByIdSelect: []
    }
  },
  computed: {
    shippingTypesSelect() {
      return this.shippingTypes.map((item) => {
        return {
          value: item.id,
          text: item.name
        }
      })
    }
  },
  methods: {
    async fetchCountries() {
      let params = {
        sort: [
          {
            key: 'name',
            direction: 'asc'
          }
        ]
      }
      return this.$http.get(this.$appConfig.api.baseUrl + 'countries', { params: params })
        .then(response => {
          this.countries = response.body.data
          this.countriesSelect = this.countries.map((item) => {
            return {
              value: item.iso_code,
              text: item.name
            }
          })
        })
    },
    // async fetchShippingTypes() {
    //   let params = {
    //     params: {
    //       sort: [{
    //         key: 'name',
    //         direction: 'asc'
    //       }]
    //     }
    //   }
    //   return this.$http.get(this.$appConfig.api.baseUrl + 'shipping-types', params)
    //     .then(response => {
    //       // this.shippingTypes = response.body.data
    //       // this.shippingTypesSelect = this.shippingTypes.map((item) => {
    //       //   return {
    //       //     value: item.id,
    //       //     text: item.name
    //       //   }
    //       // })
    //       console.log('Shipping Types Fetched OK!')
    //     })
    // },
    async fetchShippingSizes() {
      let params = {
        params: {
          sort: [{
            key: 'max_weight',
            direction: 'asc'
          }]
        }
      }
      return this.$http.get(this.$appConfig.api.baseUrl + 'sizes', params)
        .then(response => {
          this.shippingSizes = response.body.data
          this.shippingSizesSelect = this.shippingSizes.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
          console.log('Shipping Sizes Fetched OK!')
        })
    },
    async fetchNotificationTypes() {
      let params = {
        params: {
          sort: [{
            key: 'name',
            direction: 'asc'
          }]
        }
      }
      return this.$http.get(this.$appConfig.api.baseUrl + 'notification-types', params)
        .then(response => {
          this.notificationTypes = response.body.data

          // Filter out country excluded notifications
          console.log(window.countries.find(x => x.iso_code === this.$store.getters.profile.company.country_iso_code))
          const countryExcludedNotifications = window.countries.find(x => x.iso_code === this.$store.getters.profile.company.country_iso_code).notification_configs.map(x => {
            return x.notification_type_id
          })
          this.notificationTypes = this.notificationTypes.filter(x => countryExcludedNotifications.indexOf(x.id) === -1)

          this.notificationTypesSelect = this.notificationTypes.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
          console.log('Notification Types Fetched OK!')
        })
    },
    async fetchWarehouses(country = null, includes = []) {
      let params = {}
      country = country || window.country
      if (country !== null) {
        params = {
          filter_groups: [{
            filters: [
              ['country_iso_code', 'eq', country]
            ]
          }]
        }
      }
      if (includes.length > 0) {
        params.includes = includes
      }
      return this.$http.get(this.$appConfig.api.baseUrl + 'warehouses', {params: params})
        .then(response => {
          this.warehouses = response.body.data
          this.warehousesSelect = this.warehouses.map((item) => {
            return {
              value: item.place_id,
              text: item.reference
            }
          })
          console.log('Warehouses Fetched OK!')
        })
    },
    async fetchWarehousesById(country = null, includes = []) {
      let params = {}
      country = country || window.country
      if (country !== null) {
        params = {
          filter_groups: [{
            filters: [
              ['country_iso_code', 'eq', country]
            ]
          }]
        }
      }
      if (includes.length > 0) {
        params.includes = includes
      }
      return this.$http.get(this.$appConfig.api.baseUrl + 'warehouses', {params: params})
        .then(response => {
          this.warehousesById = response.body.data
          this.warehousesByIdSelect = response.body.data.map((item) => {
            return {
              value: item.id,
              text: item.reference
            }
          })
          console.log('Warehouses By ID Fetched OK!')
        })
    }
  }
}
